import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04267c02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-mask"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "tables-wrapper" }
const _hoisted_5 = { class: "table-block" }
const _hoisted_6 = { class: "table-container" }
const _hoisted_7 = { class: "backtest-table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { class: "col-tracking" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-period" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-data" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-data" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-data" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col-tracking" }, "数据跟踪"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-period" }, "统计周期"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "成功率"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "持有周期"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "平均涨幅")
  ])
], -1))
const _hoisted_10 = ["rowspan"]
const _hoisted_11 = { class: "col-period cell-border-right" }
const _hoisted_12 = { class: "table-block model-block" }
const _hoisted_13 = { class: "table-container" }
const _hoisted_14 = { class: "backtest-table" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { class: "col-tracking" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-period" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-data" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-data" }),
  /*#__PURE__*/_createElementVNode("col", { class: "col-data" })
], -1))
const _hoisted_16 = { class: "col-tracking" }
const _hoisted_17 = { class: "model-title" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 量化模型收益分析 ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-popover" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "年化超额"),
  /*#__PURE__*/_createElementVNode("p", { class: "info-desc" }, "是指策略整体收益率与基准指数的收益率差值，这里我们选取了中证1000作为基准指数，统计起始日为2024年1月2日"),
  /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "夏普比率"),
  /*#__PURE__*/_createElementVNode("p", { class: "info-desc" }, "是衡量策略收益与波动风险的性价比，数值越高，代表在同等风险下收益越高、净值走势越平稳"),
  /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "盈亏比"),
  /*#__PURE__*/_createElementVNode("p", { class: "info-desc" }, "衡量策略单次盈利与单次亏损的比值，数值越高代表抗风险和长期盈利能力越好")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-icon commonquestion" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-period" }, "统计周期", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "年化超额", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "夏普比率", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-data" }, "盈亏比", -1))
const _hoisted_25 = ["rowspan"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "model-title" }, " 量化模型收益分析 ", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "col-period cell-border-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["quant-gold-backtest", _ctx.theme])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.holdPeriodData, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: 'hold-' + index
                }, [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        rowspan: _ctx.holdPeriodData.length,
                        class: "col-tracking cell-border-right"
                      }, " 持有周期：进场——>离场信号 ", 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.period), 1),
                  _createElementVNode("td", {
                    class: "col-data",
                    style: _normalizeStyle({ color: _ctx.getChangeColor(item.successRate) })
                  }, _toDisplayString(_ctx.formatPercent(item.successRate)), 5),
                  _createElementVNode("td", {
                    class: "col-data",
                    style: _normalizeStyle({ color: _ctx.getHoldDaysColor(item.holdDays) })
                  }, _toDisplayString(_ctx.formatDays(item.holdDays)), 5),
                  _createElementVNode("td", {
                    class: "col-data",
                    style: _normalizeStyle({ color: _ctx.getChangeColor(item.avgIncrease) })
                  }, _toDisplayString(_ctx.formatPercent(item.avgIncrease)), 5)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("table", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_a_popover, {
                      placement: "right",
                      overlayClassName: "quant-gold-info-popover",
                      getPopupContainer: _ctx.getPopupContainer
                    }, {
                      content: _withCtx(() => [
                        _hoisted_19
                      ]),
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["getPopupContainer"])
                  ])
                ]),
                _hoisted_21,
                _hoisted_22,
                _hoisted_23,
                _hoisted_24
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelReturnData, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: 'model-' + index
                }, [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        rowspan: _ctx.modelReturnData.length,
                        class: "col-tracking cell-border-right model-tracking-cell"
                      }, _hoisted_27, 8, _hoisted_25))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(item.period), 1),
                  _createElementVNode("td", {
                    class: "col-data",
                    style: _normalizeStyle({ color: _ctx.getChangeColor(item.annualExcess) })
                  }, _toDisplayString(_ctx.formatPercent(item.annualExcess)), 5),
                  _createElementVNode("td", {
                    class: "col-data",
                    style: _normalizeStyle({ color: _ctx.getSharpeColor(item.sharpeRatio) })
                  }, _toDisplayString(_ctx.formatSharpe(item.sharpeRatio)), 5),
                  _createElementVNode("td", {
                    class: "col-data",
                    style: _normalizeStyle({ color: _ctx.getVsOneColor(item.profitLossRatio) })
                  }, _toDisplayString(_ctx.formatProfitLossRatio(item.profitLossRatio)), 5)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 2))
}